import React, { useState } from 'react';
import ModalContainer from './container';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, openModal } from './services';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';

const BootstrapDialog = styled(Dialog)(({ theme, content }) => ({
    '& .MuiDialogContent-root': {
        padding: 0,
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiPaper-root': {
        borderRadius: '16px',
    }
}));

const Modal = () => {
    const { open, content } = useSelector((store) => store.modal);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(closeModal());
    };

    return (
        <div>
            {open ?             
            <ModalContainer 
                open={open} 
                content={content}
                handleClose={handleClose}
                BootstrapDialog={BootstrapDialog}
            />
            :null}
        </div>
    );
};

export default Modal;
